<script setup lang="ts">
withDefaults(
  defineProps<{
    label?: string;
    disabled?: boolean;
    type?: 'button' | 'submit' | 'reset';
  }>(),
  {
    label: 'ENTRAR',
    disabled: false,
    type: 'submit',
  },
);
</script>

<template>
  <button
    class="w-full h-12 px-4 py-3 rounded-[10px] inline-flex justify-center items-center gap-2.5 transition bg-[radial-gradient(ellipse_138.00%_168.30%_at_36.76%_-16.67%,_#FF704A_0%,_#FF3400_100%)] text-white hover:brightness-110"
    :disabled="disabled"
    :type="type"
  >
    <span
      class="text-center justify-center text-white text-base font-extrabold leading-3 uppercase"
    >
      {{ label }}
    </span>
  </button>
</template>
